export const uninstalledData = {
  message: 'Dispositivo liberado exitosamente',
  status: 200,
  data: {
    device_id: '234234wer3'
  }
}

export const uninstallAppData = {
  message: 'Información del dispositivo encontrada satisfactoriamente',
  status: 200,
  data: {
    imei: '867400078238544',
    registersNumber: '123',
    brand: 'Xiaomi',
    model: 'Ascend 1'
  }
}
